import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  accept() {
    const d = new Date()
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000)
    document.cookie = "cookie-consent=true;expires=" + d.toUTCString() + ";path=/"

    // Closing the dialog grants ad + analytics consent (Consent Mode v2). Mirrors the
    // server-rendered "granted" default used on subsequent sessions.
    if (typeof gtag !== "undefined") {
      gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      })
    }

    this.element.remove()
  }
}
